var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-container',{staticClass:"home-hero",staticStyle:{"max-height":"100vh"},attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":"","fill-height":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }